<template>
  <ElConfigProvider :locale="ptBR">
    <NuxtLoadingIndicator />

    <MenuSideBar />

    <nav class="fixed top-0 z-10 w-full bg-white border-b border-grayborder">
      <div class="px-3 py-3 lg:px-5 lg:pl-3">
        <div class="flex items-center justify-between">
          <div class="flex items-center">
            <nuxt-link to="/" class="flex ml-2 mr-10">
              <span
                class="self-center primary text-xl font-semibold sm:text-2xl whitespace-nowrap"
              >
                <img src="/ooadmin.png" class="h-[45px]" />
              </span>
            </nuxt-link>

            <NuxtIcon
              :name="uiStore.menushow ? 'menu-unfold' : 'menu-fold'"
              filled
              class="text-[25px] text-gray-500 p-0 m-0 hidden lg:block cursor-pointer"
              @click="toogleMenu"
            />
          </div>

          <UserMenu />
        </div>
      </div>
    </nav>

    <div
      class="mt-4 pt-4 lg:pt-14 mb-10"
      :class="uiStore.menushow ? 'ml-0' : 'ml-0 lg:ml-64'"
    >
      <div class="mt-10" v-if="uiStore.avisoWidth">
        <ElAlert type="warning" title="Atenção" :closable="false" effect="dark" show-icon>
          <p class="text-[13px]">
            <strong>OOAdmin</strong> não foi construído para ser utilizado em dispositivos
            móveis.
          </p>
          <p class="text-[13px]">
            Por favor, acesse pelo computador ou notebook. Tables com resolução maior que
            1024px também são suportadas.
          </p>
        </ElAlert>
      </div>

      <div
        class="m-2 lg:m-4 p-1 lg:p-4 border-2 border-grayborder bg-white shadow-sm rounded-lg mt-14"
      >
        <slot />
      </div>
    </div>

    <div class="relative bottom-0 w-full bg-gray-800/5">
      <div class="flex justify-end p-4">
        <div>
          Versão <span>{{ config.public.sistemaVersao }}</span>
        </div>
      </div>
    </div>

    <button
      id="to-top-button"
      @click="goToTop()"
      title="Go To Top"
      class="hidden fixed z-50 bottom-14 right-5 lg:right-8 border-0 w-12 h-12 lg:w-14 lg:h-14 rounded-full drop-shadow-md bg-indigo-500 text-white"
    >
      <Icon name="solar:alt-arrow-up-outline" class="text-[30px]" />
    </button>
  </ElConfigProvider>
</template>

<script setup>
import ptBR from "element-plus/dist/locale/pt-br.mjs";

const config = useRuntimeConfig();

import { useUiStore } from "~/stores/ui.store";
const uiStore = useUiStore();

import { useUserStore } from "../stores/usuario_store";
const userStore = useUserStore();

const isAutenticated = ref(false);

isAutenticated.value = await userStore.isAuthenticated;

onMounted(() => {
  uiStore.menuClose();
  teste();
});

function teste() {
  var toTopButton = document.getElementById("to-top-button");

  // When the user scrolls down 200px from the top of the document, show the button
  window.onscroll = function () {
    if (document.body.scrollTop > 250 || document.documentElement.scrollTop > 250) {
      toTopButton.classList.remove("hidden");
    } else {
      toTopButton.classList.add("hidden");
    }
  };
}

function goToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

function toogleMenu() {
  uiStore.toogleMenu();
}
</script>
